type SiteStatementIfSorts =
    'notNullOrUndefined' | 'nullOrUndefined' |
    'notNullOrEmpty' | 'nullOrEmpty' |
    'equals' | 'notEquals' | 'equalsType' |
    'greaterThan' | 'smallerThan' | 'greaterOrEquals' | 'smallerOrEquals' |
    'contains' | 'notContains';

class SiteStatementIf
    extends QueryElement<HTMLElement> {
    
    constructor(card: ISiteCard, element: HTMLElement) {
        super(element, false);

        let path = this.getAttr('data-path');
        let sort = this.getAttr('data-sort') as SiteStatementIfSorts;
        let compareValue = this.getAttr('data-value') as any;
        let value = card.Model.get((path && SiteModel.split(path)) || []) as any;

        let show = false;
        switch (sort) {
            case 'contains':
                show = value.includes(compareValue);
                break;
            case 'notContains':
                show = !value.includes(compareValue);
                break;
            case 'notNullOrUndefined':
                show = value != null;
                break;
            case 'notNullOrEmpty':
                show = value != null && value.length > 0
                break;
            case 'nullOrUndefined':
                show = value == null;
                break;
            case 'nullOrEmpty':
                show = value == null || value.length == 0
                break;
            case 'equalsType':
            case 'equals':
                show = value == compareValue;
                break;
            case 'notEquals':
                show = value != compareValue;
                break;
            case 'greaterThan':
                show = value > compareValue;
                break;
            case 'greaterOrEquals':
                show = value >= compareValue;
                break;
            case 'smallerThan':
                show = value < compareValue;
                break;
            case 'smallerOrEquals':
                show = value <= compareValue;
                break;
        }
        
        // Make this tag dissapear
        if (show) {
            let parent = this.parent();
            if (parent != null)
                for (let x of this.children()) {
                    parent.insertBefore(x, this);
                }
        }

        element.remove();
    }
}